import React from 'react'
function TableBody(props) {
    return(
        <tbody>{props.children}</tbody>
    )
}
export default TableBody;